import { SignupInput as StyledInput, SignupAddressInput } from './signupInputStyles';
import CareerYearsField, { careerYearsError, careerYearsOf } from '@/components/domain/member/CareerYearsField';
import { normalizeSignupPhone } from '@/utils/signupPhone';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { yupResolver } from "@hookform/resolvers/yup";
import { trackEvent } from '@/common/analytics';
import { Controller, useForm } from 'react-hook-form';
import { SignUpValidate } from '@/utils/form.utils';
import * as yup from "yup";
import Container from '@/components/common/elements/Container';
import Text from '@/components/common/elements/Text';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { filterNumericInput } from '@/utils/filterNumberInput';
import { convertToDate } from '@/utils/convertToDate';
import { addressCodeFields } from '@/utils/regionLabel';
import { useSetRecoilState } from 'recoil';
import { SignupMeta, SubwayArea as Subway, Option } from '@/api/repository/types/types';
import { toastState } from '@/state/toastState';
import { useIsMobile, useValidateInput } from '@/common/hooks';
import { useResultModal } from '@/hooks/useResultModal';
import SelectBox from '@/components/common/elements/SelectBox';
import AddressSearchFiled from '@/components/common/organism/AddressSearchFiled';
import { api } from '@/api/repository/axios';
import RegionSelector from '@/components/common/organism/RegionSelector';
import EmailVerifyField from '@/components/common/organism/EmailVerifyField';
import { BirthdayCheck, checkBirthday, isMobilePhone } from '@/utils/birthday';
import { KakaoAddressDocument } from '@/common/types';

import { designSystem } from '@/styles/theme';

// Styled Components - 속닥속닥 스타일
const FormContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 8px 0;
`;

const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const Label = styled.label`
    font-size: 0.95rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 4px;

    span {
        color: #dc2626;
        margin-left: 2px;
    }
`;

/** 생년월일 풀어 보여 주기 — "1995년 3월 2일 · 만 31세 — 맞는지 확인해 주세요" */
const BirthdayConfirm = styled.p`
    margin: 6px 0 0;
    font-size: 13px;
    font-weight: 600;
    color: ${designSystem.colors.primary};
`;

const HelpText = styled.p`
    font-size: 0.85rem;
    color: #6b7280;
    margin: 0 0 8px 0;
`;





const ErrorMessage = styled.p`
    font-size: 0.85rem;
    color: #dc2626;
    margin: 4px 0 0 0;
`;

const InputWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const ValidMessage = styled.span<{ color?: string }>`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.85rem;
    font-weight: 600;
    color: ${props => props.color};
    white-space: nowrap;
    pointer-events: none;
`;

const SectionDivider = styled.div`
    height: 1px;
    background-color: #f0f0f0;
    margin: 8px 0;
`;

const SectionTitle = styled.h2`
    font-size: 1.1rem;
    font-weight: 600;
    color: #1a1a1a;
    margin: 16px 0 0 0;
    padding-bottom: 8px;
    border-bottom: 2px solid ${designSystem.colors.primary};
    display: inline-block;
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
    padding-top: 24px;
    margin-top: 16px;
    border-top: 1px solid #f0f0f0;
`;

const CancelButton = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px 24px;
    background-color: #f3f4f6;
    color: #374151;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    transition: all 0.2s ease;

    &:hover {
        background-color: #e5e7eb;
    }

    @media (max-width: 768px) {
        flex: 1;
        justify-content: center;
        padding: 10px 20px;
        font-size: 14px;
    }
`;

const SubmitButton = styled.button<{ disabled?: boolean }>`
    padding: 12px 24px;
    background-color: ${props => props.disabled ? '#e2e8f0' : designSystem.colors.primary};
    color: ${props => props.disabled ? '#94a3b8' : '#ffffff'};
    border: none;
    border-radius: 8px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    font-size: 15px;
    font-weight: 600;
    transition: all 0.2s ease;
    box-shadow: ${props => props.disabled ? 'none' : '0 2px 4px rgba(0, 0, 0, 0.2)'};

    &:hover {
        background-color: ${props => props.disabled ? '#e2e8f0' : designSystem.colors.primaryDark};
    }

    @media (max-width: 768px) {
        flex: 1;
        padding: 10px 20px;
        font-size: 14px;
    }
`;

const TagSelector = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

const TagOption = styled.button<{ selected: boolean }>`
    padding: 10px 20px;
    border: 2px solid ${props => props.selected ? designSystem.colors.primary : '#e5e7eb'};
    background: ${props => props.selected ? designSystem.colors.primaryLight : '#fff'};
    color: ${props => props.selected ? designSystem.colors.primary : claudeTokens.color.text2};
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: ${props => props.selected ? '600' : '500'};
    transition: all 0.2s ease;

    &:hover {
        border-color: ${designSystem.colors.primary};
        background: ${props => props.selected ? designSystem.colors.primaryLight : '#faf9ff'};
    }
`;

const InputWithIcon = styled.div`
    position: relative;
    width: 100%;
`;

const InputIcon = styled.span`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.85rem;
    color: #6b7280;
`;

const TwoColumnGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px;
    align-items: end;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

/** 선택 입력 표시 — 필수(*)와 구분되는 회색 보조 텍스트 */
const OptionalMark = styled.span`
    && {
        color: #6b7280;
        font-size: 0.8rem;
        font-weight: normal;
        margin-left: 0;
    }
`;

const GenderButtons = styled.div`
    display: flex;
    gap: 8px;
`;

const GenderButton = styled.button<{ selected: boolean }>`
    padding: 12px 24px;
    border: 2px solid ${props => props.selected ? designSystem.colors.primary : '#e5e7eb'};
    background: ${props => props.selected ? designSystem.colors.primary : '#fff'};
    color: ${props => props.selected ? '#fff' : claudeTokens.color.text2};
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;
    min-width: 60px;

    &:hover {
        border-color: ${designSystem.colors.primary};
    }
`;

const SelectWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const checkBoxOptions = [
    { value: true, label: '경력' },
    { value: false, label: '신입' },
];

type SignUpFormData = yup.InferType<typeof SignUpValidate>;

import type { SocialSignupState } from '@/pages/Signup/Signup';
import { TermsId, TERMS_VERSION } from '@/pages/Signup/termsContent';
import { LICENSE_BIRTHDAY_REQUIRED_MESSAGE } from '@/common/licenseVerification';
import ButtonSpinner from '@/components/common/elements/ButtonSpinner';
import { claudeTokens } from '@/styles/claudeTokens';

interface UserInputProps {
    onStep: (isStep: number) => void;
    socialState?: SocialSignupState | null;
    agreements?: Record<TermsId, boolean>;
}

const buildInitialBirthday = (socialProfile?: SocialSignupState['socialProfile']) => {
    if (!socialProfile?.birthyear || !socialProfile?.birthday) return '';
    // 네이버 birthday: "MM-DD", birthyear: "YYYY" → "YYYYMMDD"
    return `${socialProfile.birthyear}${socialProfile.birthday.replace('-', '')}`;
};

const GeneralSignUpForm = ({ onStep, socialState, agreements }: UserInputProps) => {
    const socialProfile = socialState?.socialProfile;
    const isSocialSignup = !!socialState?.socialAccessToken;
    const isMobile = useIsMobile();
    const setToast = useSetRecoilState(toastState);
    const { showError, showErrorMessage, resultModal } = useResultModal();
    const [isSubmitting, setIsSubmitting] = useState(false);
    // [APPSTORE-5.1.1(v) 임시 완화] 성별은 선택 입력 — 기본 미선택(null). 소셜 프로필에 값이 있으면 프리필. (이전: 기본 'MAN' 고정)
    const [selectedGender, setSelectedGender] = useState<"MAN" | "WOMAN" | null>(
        socialProfile?.gender === 'F' ? 'WOMAN' : socialProfile?.gender === 'M' ? 'MAN' : null
    );
    const [birthday, setBirthday] = useState(buildInitialBirthday(socialProfile));
    const [userType, setUserType] = useState({ description: "", type: "" });
    const [isUserTypeOpen, setIsUserTypeOpen] = useState(false);
    const [signupMeta, setSignupMeta] = useState<SignupMeta | null>(null);
    /** 연차(필수, 회원 정보) — '' 미입력 / '0' 신입 / 'N' 경력 N년 */
    const [careerYears, setCareerYears] = useState<string>('');
    const [careerChosen, setCareerChosen] = useState<boolean>(false);
    const [isButtonState, setIsButtonState] = useState(false);
    const [roadAddressName, setRoadAddressName] = useState("");
    /** 고른 주소의 카카오 b_code 원문 — 지역 판정은 서버가 한다 */
    const [addressCode, setAddressCode] = useState<string | undefined>(undefined);
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [passwordConfirm, setPasswordConfirm] = useState<string>('');
    // 소셜 프로필에 이메일이 있으면 해당 소셜에서 검증된 것으로 간주(인증 면제).
    // Apple 은 '이메일 가리기'·재인증 시 이메일을 안 줄 수 있다 → 이 경우 직접 입력 + 이메일 인증 필수.
    const socialEmailVerified: boolean = isSocialSignup && !!socialProfile?.email;
    const [emailVerified, setEmailVerified] = useState<boolean>(socialEmailVerified);
    const { validateMessage: nickNameValidateMessage, isValidColor: isNickNameValidColor, handleBlur: handleNickNameBlur, isSuss: isNicknameSuss } = useValidateInput();

    const {
        control,
        handleSubmit,
        formState: { errors, isValid },
        reset,
        setValue,
        watch,
    } = useForm({
        resolver: yupResolver(SignUpValidate),
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            password: isSocialSignup ? `Social!${crypto.randomUUID()}` : '',
            nickName: socialProfile?.nickname || socialProfile?.name || '',
            name: socialProfile?.name || '',
            birthday: buildInitialBirthday(socialProfile),
            phone: normalizeSignupPhone(socialProfile?.phoneNumber),
            userType: '',
            // 검증 이메일이 없으면 Apple 이 준 미검증 이메일을 프리필만 한다(잠금·인증면제 아님).
            email: socialProfile?.email || socialProfile?.suggestedEmail || '',
            address: '',
            detailAddress: '',
            subwayStation: [],
            licenseNumber: '',
        },
    });

    const watchValue = watch();

    const scrollToError = (fieldName: keyof SignUpFormData | string) => {
        // 필드 이름에 매칭되는 input/select를 form 안에서 찾아 scroll + focus
        const target = document.querySelector(
            `[name="${fieldName}"], [data-field="${fieldName}"]`
        ) as HTMLElement | null;
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => target.focus?.(), 300);
        }
        // fallback 으로 userIdRef 로 가지 않음 (치과 회원가입과 동일 정책 — 사용자가 왜 거기로 가는지 모름)
    };

    const handleInvalidSubmit = (errors: any) => {
        const firstErrorField = Object.keys(errors)[0] as keyof SignUpFormData;
        if (firstErrorField) {
            scrollToError(firstErrorField);
        }
    };

    // 면허번호를 입력하면 생년월일이 필수다(면허 진위 확인에 성명·생년월일·면허번호가 함께 필요).
    // 면허번호가 없으면 생년월일은 기존대로 선택 입력.
    const isLicenseEntered: boolean = !!watchValue.licenseNumber?.trim();
    const isBirthdayRequiredByLicense: boolean = isLicenseEntered && birthday.length !== 8;
    const birthdayCheck: BirthdayCheck = checkBirthday(birthday);

    const validateFields = () => {
        const fieldsToCheck = [
            // 네이버 가입은 비밀번호를 자동 생성하므로 검증 대상에서 제외
            ...(isSocialSignup ? [] : [
                { value: watchValue.password, name: "비밀번호" },
                { value: passwordConfirm && passwordConfirm === watchValue.password, name: "비밀번호 확인" },
            ]),
            { value: watchValue.nickName, name: "닉네임" },
            { value: watchValue.name, name: "이름" },
            // [APPSTORE-5.1.1(v) 임시 완화] 생년월일·전화번호·주소 필수 검증 제거. 이전 항목:
            //   { value: birthday && birthday.length === 8, name: "생년월일" }, { value: watchValue.phone, name: "전화번호" }, { value: roadAddressName, name: "주소" }
            // 생년월일은 선택이지만, 입력을 시작했다면 8자리를 채워야 한다.
            // 단, 면허번호를 입력했다면 8자리 생년월일이 필수다.
            // 생년월일은 필수(2026-09-27 — 전화번호와 함께 다시 필수로). 달력에 있는 날짜·말이 되는 나이여야 한다.
            { value: checkBirthday(birthday).ok, name: "생년월일" },
            // 전화번호는 필수(2026-09-27) — 휴대폰 형식까지 맞아야 한다
            { value: isMobilePhone(watchValue.phone), name: "전화번호" },
            { value: watchValue.userType, name: "회원구분" },
            // 연차는 필수(2026-10-17) — 신입(0)도 값이다
            { value: careerYearsError(careerYears, careerChosen) === null, name: "연차" },
            { value: watchValue.email, name: "이메일" },
        ];

        return fieldsToCheck
            .filter(field => !field.value || (Array.isArray(field.value) && field.value.length === 0))
            .map(field => field.name);
    };

    // 한글 라벨명 → form field name 매핑 (스크롤 타겟 결정용)
    const FIELD_NAME_MAP: Record<string, string> = {
        "비밀번호": "password",
        "비밀번호 확인": "password",
        "닉네임": "nickName",
        "이름": "name",
        "생년월일": "birthday",
        "전화번호": "phone",
        "회원구분": "userType",
        "연차": "careerYears",
        "이메일": "email",
        "주소": "address",
    };

    const onSubmit = (data: SignUpFormData) => {
        const updatedMissingFields = validateFields();

        if (updatedMissingFields.length) {
            setMissingFields(updatedMissingFields);
            const firstField = FIELD_NAME_MAP[updatedMissingFields[0]];
            if (firstField) {
                scrollToError(firstField as keyof SignUpFormData);
            }
            return;
        }

        // 사용가능/사용불가 검증 — 상단 우선순위로 체크 후 미통과 시 해당 필드로 포커싱 (시스템 alert 미사용)
        if (!isSocialSignup && (!passwordConfirm || passwordConfirm !== watchValue.password)) {
            setMissingFields(['비밀번호 확인']);
            scrollToError('password');
            return;
        }
        if (!isNicknameSuss) {
            // 닉네임 중복확인이 안 된 상태 → 즉시 서버 검증을 실행해 사용가능/사용불가(빨간 글씨) 메시지를 노출하고 스크롤.
            // (소셜 프리필·무-blur로 검증이 누락된 채 제출돼 아무 표시 없이 스크롤만 되던 문제 대응)
            handleNickNameBlur(watchValue.nickName, 'nickName');
            scrollToError('nickName');
            return;
        }
        // 이메일 인증 필수 (소셜 프로필 이메일이 있으면 사전 인증 완료로 간주하여 면제)
        if (!emailVerified) {
            setMissingFields(['이메일']);
            scrollToError('email');
            return;
        }

        setIsSubmitting(true);
        api.signUp({
            password: watchValue.password,
            name: watchValue.name,
            nickname: watchValue.nickName,
            // [APPSTORE-5.1.1(v) 임시 완화] 선택 항목은 비어 있으면 보내지 않는다 (서버 nullable)
            // 서버 계약은 yyyy-MM-dd — 8자리 그대로 보내면 서버가 epoch millis 로 오해석해 1970-01-01 이 저장된다
            birthDate: birthday.length === 8
                ? `${birthday.slice(0, 4)}-${birthday.slice(4, 6)}-${birthday.slice(6, 8)}`
                : undefined,
            genderType: selectedGender ?? undefined,
            userType: watchValue.userType,
            careerYears: careerYearsOf(careerYears) ?? undefined,
            licenseNumber: watchValue.licenseNumber,
            signupVersion: 2,
            phoneNumber: normalizeSignupPhone(watchValue.phone),
            email: watchValue.email,
            authority: 'ROLE_USER',
            districtId: watchValue.address || undefined,
            addressCode: addressCode,
            stationIds: (watchValue.subwayStation ?? []).filter((id): id is string => !!id),
            address: roadAddressName || undefined,
            addressDetail: watchValue.detailAddress || undefined,
            socialAccessToken: socialState?.socialAccessToken,
            socialProvider: socialState?.socialProvider,
            agreements: agreements,
            termsVersion: TERMS_VERSION,
        }).then((res) => {
            if (res.message === "성공") {
                // 캠페인 가입 전환 집계: 가입 완료 시점에 SIGNUP 이벤트 전송(UTM은 세션에서 자동 첨부)
                trackEvent('SIGNUP');
                onStep(4);
            } else {
                showErrorMessage(res.message || '회원가입에 실패했습니다.');
            }
        }).catch((error) => {
            console.error('signUp error:', error);
            // 서버 원문 노출 방지 — 정책에 따라 안전한 문구로. 미정의 에러는 일반 문구.
            showError(error, '회원가입 실패');
        }).finally(() => {
            setIsSubmitting(false);
        });
    };

    // 같은 버튼을 다시 누르면 선택 해제 (선택 입력)
    const handleGender = (value: "MAN" | "WOMAN") => {
        setSelectedGender(prev => (prev === value ? null : value));
    };

    const handleBirthdayChange = (value: string) => {
        const filterNumber = filterNumericInput(value);
        const convertToDateValue = convertToDate(filterNumber);
        if (convertToDateValue) {
            const isoString = convertToDateValue.toISOString();
            setValue("birthday", isoString);
        }
        setBirthday(filterNumber);
    };

    const handleUserTypeChange = (selected: Option) => {
        setUserType(selected);
        setValue("userType", selected.type);
    };

    useEffect(() => {
        const passwordConfirmed = isSocialSignup || (!!passwordConfirm && passwordConfirm === watchValue.password)
        const birthdayOk = checkBirthday(birthday).ok
        const buttonValid = isValid && birthdayOk && isMobilePhone(watchValue.phone) && isNicknameSuss && emailVerified && passwordConfirmed
        setIsButtonState(buttonValid);
    }, [isValid, birthday, isLicenseEntered, watchValue.phone, isNicknameSuss, emailVerified, passwordConfirm, watchValue.password, isSocialSignup]);

    // 소셜 가입은 닉네임이 프로필값으로 자동 입력되는데, 사용자가 필드를 blur하지 않으면
    // 닉네임 중복확인(isNicknameSuss)이 실행되지 않아 제출이 조용히 막힌다(스크롤만 되고 메시지 없음).
    // → 마운트 시 프리필 닉네임을 1회 자동 검증해 게이트가 실제 사용가능 여부를 반영하고 피드백도 노출한다.
    useEffect(() => {
        const prefilledNickname = socialProfile?.nickname || socialProfile?.name;
        if (isSocialSignup && prefilledNickname) {
            handleNickNameBlur(prefilledNickname, 'nickName');
        }
        // 마운트 시 1회만 실행
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // missingFields 자동 클린업: 사용자가 누락 필드를 채우면 빨간 underline 즉시 제거
    useEffect(() => {
        if (missingFields.length === 0) return;
        const stillMissing: string[] = missingFields.filter((f) => {
            if (f === '비밀번호') return !watchValue.password;
            if (f === '비밀번호 확인') return !passwordConfirm || passwordConfirm !== watchValue.password;
            if (f === '닉네임') return !watchValue.nickName;
            if (f === '이름') return !watchValue.name;
            if (f === '생년월일') return !checkBirthday(birthday).ok;
            if (f === '전화번호') return !isMobilePhone(watchValue.phone);
            if (f === '회원구분') return !watchValue.userType;
            if (f === '연차') return careerYearsError(careerYears, careerChosen) !== null;
            if (f === '이메일') return !watchValue.email;
            return true;
        });
        if (stillMissing.length !== missingFields.length) {
            setMissingFields(stillMissing);
        }
    }, [
        watchValue.password, passwordConfirm,
        watchValue.nickName, watchValue.name, birthday,
        watchValue.phone, watchValue.userType, watchValue.email,
        watchValue.licenseNumber,
        roadAddressName,
        careerYears, careerChosen,
    ]);

    useEffect(() => {
        const fetchSignupMeta = async () => {
            try {
                const response = await api.signup.usersMeta();
                setSignupMeta(response.result);
            } catch (error) {
                console.error("Failed to fetch signup meta:", error);
            }
        };

        fetchSignupMeta();
    }, []);

    return (
        <FormContent>
            {resultModal}
            <SectionTitle>기본정보</SectionTitle>
            <HelpText>회원가입을 위한 기본 정보를 입력해주세요</HelpText>

            <FormGroup>
                <Label>이메일<span>*</span></Label>
                <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                        <EmailVerifyField
                            name="email"
                            email={field.value ?? ''}
                            onChangeEmail={(v) => field.onChange(v)}
                            verified={emailVerified}
                            onVerifiedChange={setEmailVerified}
                            locked={socialEmailVerified}
                            hasError={missingFields.includes('이메일') || !!errors.email}
                        />
                    )}
                />
                {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
            </FormGroup>

            {!isSocialSignup && (
                <>
                    <FormGroup>
                        <Label>비밀번호<span>*</span></Label>
                        <Controller
                            name="password"
                            control={control}
                            render={({ field }) => (
                                <StyledInput
                                    {...field}
                                    type="password"
                                    placeholder="비밀번호를 입력해주세요"
                                    hasError={missingFields.includes('비밀번호') || !!errors.password}
                                />
                            )}
                        />
                        {errors.password && <ErrorMessage>{errors.password.message}</ErrorMessage>}
                    </FormGroup>

                    <FormGroup>
                        <Label>비밀번호 확인<span>*</span></Label>
                        <InputWrapper>
                            <StyledInput
                                type="password"
                                value={passwordConfirm}
                                onChange={(e) => setPasswordConfirm(e.target.value)}
                                placeholder="비밀번호를 다시 한 번 입력해주세요"
                                hasError={missingFields.includes('비밀번호 확인') || (passwordConfirm.length > 0 && passwordConfirm !== watchValue.password)}
                            />
                            {passwordConfirm.length > 0 && (
                                <ValidMessage color={passwordConfirm === watchValue.password ? '#10b981' : '#dc2626'}>
                                    {passwordConfirm === watchValue.password ? '일치' : '불일치'}
                                </ValidMessage>
                            )}
                        </InputWrapper>
                    </FormGroup>
                </>
            )}

            <FormGroup>
                <Label>닉네임<span>*</span></Label>
                <InputWrapper>
                <Controller
                    name="nickName"
                    control={control}
                    render={({ field }) => (
                        <StyledInput
                            {...field}
                            placeholder="닉네임을 입력해주세요 (2자 이상)"
                            hasError={missingFields.includes('닉네임') || !!errors.nickName}
                            onBlur={(e) => {
                                field.onBlur();
                                if (errors.nickName) return;
                                handleNickNameBlur(field.value, "nickName");
                            }}
                        />
                    )}
                />
                {watchValue.nickName && !errors.nickName && nickNameValidateMessage && (
                    <ValidMessage color={isNicknameSuss ? '#10b981' : '#dc2626'}>
                        {nickNameValidateMessage}
                    </ValidMessage>
                )}
                </InputWrapper>
                {errors.nickName && <ErrorMessage>{errors.nickName.message}</ErrorMessage>}
            </FormGroup>

            <FormGroup>
                <Label>이름<span>*</span> <OptionalMark>· 성별은 선택</OptionalMark></Label>
                <TwoColumnGrid>
                    <Controller
                        name="name"
                        control={control}
                        render={({ field }) => (
                            <StyledInput
                                {...field}
                                placeholder="이름을 입력해주세요"
                                hasError={missingFields.includes('이름') || !!errors.name}
                            />
                        )}
                    />
                    <GenderButtons>
                        <GenderButton
                            type="button"
                            selected={selectedGender === "MAN"}
                            onClick={() => handleGender("MAN")}
                        >
                            남
                        </GenderButton>
                        <GenderButton
                            type="button"
                            selected={selectedGender === "WOMAN"}
                            onClick={() => handleGender("WOMAN")}
                        >
                            여
                        </GenderButton>
                    </GenderButtons>
                </TwoColumnGrid>
                {errors.name && <ErrorMessage>{errors.name.message}</ErrorMessage>}
            </FormGroup>

            <FormGroup>
                <Label>
                    생년월일 <span>*</span>
                </Label>
                <Controller
                    name="birthday"
                    control={control}
                    render={({ field }) => (
                        <StyledInput
                            {...field}
                            value={birthday}
                            maxLength={8}
                            onChange={(e) => handleBirthdayChange(e.target.value)}
                            placeholder="YYYYMMDD (예: 19950302)"
                            hasError={missingFields.includes('생년월일') || !!errors.birthday}
                        />
                    )}
                />
                {/* 8자리를 다 넣으면 "1995년 3월 2일 · 만 31세"로 풀어 보여 줘 오입력을 바로 알아채게 한다 */}
                {birthday.length === 8 ? (
                    birthdayCheck.ok
                        ? <BirthdayConfirm>{birthdayCheck.text} — 맞는지 확인해 주세요</BirthdayConfirm>
                        : <ErrorMessage>{birthdayCheck.error}</ErrorMessage>
                ) : missingFields.includes('생년월일') ? (
                    <ErrorMessage>
                        {isBirthdayRequiredByLicense
                            ? LICENSE_BIRTHDAY_REQUIRED_MESSAGE
                            : '생년월일을 YYYYMMDD 8자리로 입력해주세요.'}
                    </ErrorMessage>
                ) : isBirthdayRequiredByLicense ? (
                    <HelpText>{LICENSE_BIRTHDAY_REQUIRED_MESSAGE}</HelpText>
                ) : null}
                {errors.birthday && <ErrorMessage>{errors.birthday.message}</ErrorMessage>}
            </FormGroup>

            <FormGroup>
                <Label>휴대폰 번호 <span>*</span></Label>
                <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => (
                        <StyledInput
                            {...field}
                            inputMode="numeric"
                            onChange={(e) => field.onChange(filterNumericInput(e.target.value).slice(0, 11))}
                            placeholder="숫자만 입력 (예: 01012345678)"
                            hasError={missingFields.includes('전화번호') || !!errors.phone}
                        />
                    )}
                />
                {errors.phone ? (
                    <ErrorMessage>{errors.phone.message}</ErrorMessage>
                ) : missingFields.includes('전화번호') ? (
                    <ErrorMessage>휴대폰 번호를 숫자만 정확히 입력해 주세요(010은 11자리).</ErrorMessage>
                ) : null}
            </FormGroup>

            <FormGroup>
                <Label>회원구분<span>*</span></Label>
                <SelectWrapper>
                    <Controller
                        name="userType"
                        control={control}
                        render={({ field }) => (
                            <StyledInput
                                {...field}
                                value={userType.description ?? ""}
                                placeholder="회원 구분을 선택해주세요"
                                readOnly
                                style={{ cursor: 'pointer' }}
                                onFocus={() => setIsUserTypeOpen(!isUserTypeOpen)}
                                hasError={missingFields.includes('회원구분') || !!errors.userType}
                            />
                        )}
                    />
                    <SelectBox
                        onOpenContrall={(open) => setIsUserTypeOpen(open)}
                        options={signupMeta?.userTypes ?? null}
                        onChange={(selected) => handleUserTypeChange(selected)}
                        isOpen={isUserTypeOpen}
                    />
                </SelectWrapper>
                {errors.userType && <ErrorMessage>{errors.userType.message}</ErrorMessage>}
            </FormGroup>

            <FormGroup>
                <Label as="div">연차<span>*</span></Label>
                <CareerYearsField
                    value={careerYears}
                    input={StyledInput}
                    error={missingFields.includes('연차') ? careerYearsError(careerYears, careerChosen) : null}
                    onChange={(next, chosen) => {
                        setCareerYears(next);
                        setCareerChosen(chosen);
                    }}
                />
            </FormGroup>

            <SectionDivider />
            <SectionTitle>주소 정보</SectionTitle>
            <HelpText>선택 사항입니다. 거주 지역을 입력하면 가까운 채용정보를 우선 보여드립니다.</HelpText>

            <FormGroup>
                <Label>주소 <OptionalMark>(선택)</OptionalMark></Label>
                <SignupAddressInput><AddressSearchFiled
                    defaultValue={roadAddressName}
                    onChange={(value: KakaoAddressDocument) => {
                        const fields = addressCodeFields(value.address?.b_code);
                        setValue("address", fields.districtId ?? '');
                        setAddressCode(fields.addressCode);
                        setRoadAddressName(value.address_name)
                    }}
                    height={48}
                    width={'100%'}
                    border={'none'}
                    borderBottom={'1px solid #e5e7eb'}

                    margin='0'
                /></SignupAddressInput>
                {errors.address && <ErrorMessage>{errors.address.message}</ErrorMessage>}
            </FormGroup>

            <FormGroup>
                <Label>상세주소</Label>
                <Controller
                    name="detailAddress"
                    control={control}
                    render={({ field }) => (
                        <StyledInput
                            {...field}
                            placeholder="상세주소를 입력해주세요"
                        />
                    )}
                />
            </FormGroup>

            <FormGroup>
                <Label>인근 지하철역 <span style={{ fontSize: '0.8rem', color: '#6b7280', fontWeight: 'normal' }}>(선택)</span></Label>
                <RegionSelector
                    onSelectedSubwayItem={(item) => setValue("subwayStation", item)}
                />
            </FormGroup>

            <SectionDivider />
            <SectionTitle>상세정보</SectionTitle>
            <HelpText>추가적인 회원 정보를 입력해주세요</HelpText>

            <FormGroup>
                <Label>면허번호</Label>
                <Controller
                    name="licenseNumber"
                    control={control}
                    render={({ field }) => (
                        <StyledInput
                            {...field}
                            placeholder="면허번호를 입력해주세요"
                        />
                    )}
                />
                {/* 면허 인증으로 달라지는 것만(코드 확인 2026-10-10): 이력서 면허 인증 배지(Resume.licenseVerified),
                    급여 실태조사 집계는 면허 인증 회원 응답만(SalarySurveyPortAdapters). 속닥속닥 글쓰기는 면허와 무관 */}
                <HelpText>
                    면허 인증을 받으면 이력서에 면허 인증 배지가 붙고, 급여 실태조사 통계에 내 응답이 반영돼요.
                </HelpText>
                <HelpText>
                    {LICENSE_BIRTHDAY_REQUIRED_MESSAGE}. 면허 인증 배지는 가입 후 마이페이지에서 면허증 이미지를 제출하고 관리자 검수를 거쳐 부여됩니다.
                </HelpText>
            </FormGroup>

            <ButtonGroup>
                <CancelButton type="button" onClick={() => onStep(2)}>
                    <KeyboardBackspaceIcon fontSize="small" /> 이전
                </CancelButton>
                <SubmitButton
                    type="button"
                    disabled={isSubmitting}
                    onClick={handleSubmit(onSubmit, handleInvalidSubmit)}
                >
                    {isSubmitting ? <ButtonSpinner /> : '회원가입'}
                </SubmitButton>
            </ButtonGroup>
        </FormContent>
    );
};

export default GeneralSignUpForm;
